/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseConversation } from '../../models/api-response-conversation';
import { ReferentialTagConversation } from '../../models/referential-tag-conversation';

export interface ManageConversationTags$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  reference: string;
      body: Array<ReferentialTagConversation>
}

export function manageConversationTags(http: HttpClient, rootUrl: string, params: ManageConversationTags$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseConversation>> {
  const rb = new RequestBuilder(rootUrl, manageConversationTags.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('reference', params.reference, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseConversation>;
    })
  );
}

manageConversationTags.PATH = '/v1/api/ui/conversation/{reference}/tags';
